module.exports = __webpack_public_path__ + "static/media/instagram.09283a2f.svg";